export default function normalizeBooleanFlag(value) {
    if (typeof value === "string") {
        return ["1", "true"].includes(value.trim().toLowerCase());
    }

    return value === true || value === 1;
}
